module.exports = __webpack_public_path__ + "img/LINE POINTS.4a74d066.png";